import {
  accountProfileRoute,
  accountEditProfileRoute,
  accountUpdatePasswordRoute
} from "./profile";
import { accountSettingRoute } from "./setting";

export const allProfileRoute = [
  accountProfileRoute(),
  accountSettingRoute(),
  accountEditProfileRoute(),
  accountUpdatePasswordRoute()
];
